import { render, staticRenderFns } from "./StudyResultModal.vue?vue&type=template&id=622d7bf0&scoped=true&lang=pug"
import script from "./StudyResultModal.vue?vue&type=script&lang=js"
export * from "./StudyResultModal.vue?vue&type=script&lang=js"
import style0 from "./StudyResultModal.vue?vue&type=style&index=0&id=622d7bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622d7bf0",
  null
  
)

export default component.exports